import React from "react";
import { useTranslation } from "react-i18next";
import { PRICES_BASE_REQUEST } from "../enums/ApiPaths";
import { SERVICES } from "../enums/QueryKeys";
import { useFetch } from "./Fetching";
import useUser from "./useUser";

export default function useGetServices() {
  const { currentClinic } = useUser();
  const { t, i18n } = useTranslation();

  const {
    data: services,
    isLoading,
    error,
  } = useFetch(PRICES_BASE_REQUEST, currentClinic?.id, SERVICES);

  const [translatedServices, setTranslatedServices] = React.useState([]);

  React.useEffect(() => {
    if (services) {
      const currentLang = i18n.language;
      const translation = services.map((service) => ({
        id: service.id,
        title: service.translations[currentLang] || service.title,
      }));
      setTranslatedServices(translation);
    }
  }, [services, i18n.language]);
  
  return { isLoading, error, translatedServices };
}
